import './NotFound.scss';
import { Link } from 'react-router-dom';

/**
 * @description NotFound component that displays a 404 error page when users navigate to
 * a non-existent route. Provides a link to return to the home page.
 *
 * @SADtrace SAD-003-1
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @returns {JSX.Element} The rendered NotFound component with 404 message
 */
const NotFound = () => {
  return (
    <div className="not-found-page" data-testid="not-found-page">
      <h1>404 Not Found</h1>
      <Link to={'/'}>Go Back</Link>
    </div>
  );
};

export default NotFound;
